import React, { useState, useEffect } from 'react';
import { Modal, Button } from 'react-bootstrap';

interface ConfirmarInicioModalProps {
    show: boolean;
    onHide: () => void;
    onConfirmar: () => void;
    candidatoNome: string;
}

const ConfirmarInicioModal: React.FC<ConfirmarInicioModalProps> = ({
    show,
    onHide,
    onConfirmar,
    candidatoNome
}) => {
    const animatedButtonStyle = {
        position: 'relative' as const,
        overflow: 'hidden' as const,
        animation: 'borderGlow 2s ease-in-out infinite'
    };

    const keyframes = `
        @keyframes borderGlow {
            0%, 100% { box-shadow: 0 0 5px rgba(108, 117, 125, 0.5); }
            50% { box-shadow: 0 0 15px rgba(108, 117, 125, 0.8), 0 0 25px rgba(108, 117, 125, 0.4); }
        }
    `;
    const [countdown, setCountdown] = useState(2);
    const [canConfirm, setCanConfirm] = useState(false);

    useEffect(() => {
        if (show) {
            setCountdown(2);
            setCanConfirm(false);

            const timer = setInterval(() => {
                setCountdown((prev) => {
                    if (prev <= 1) {
                        setCanConfirm(true);
                        clearInterval(timer);
                        return 0;
                    }
                    return prev - 1;
                });
            }, 1000);

            return () => clearInterval(timer);
        }
    }, [show]);

    const handleConfirmar = () => {
        onConfirmar();
        onHide();
    };

    return (
        <>
            <style>{keyframes}</style>
            <Modal show={show} onHide={onHide} centered size="sm">
                <Modal.Header closeButton className="border-0">
                    <Modal.Title className="fs-6 text-muted"></Modal.Title>
                </Modal.Header>
                <Modal.Body className="py-4">
                    <div className="text-center">
                        <p className="mb-4 text-dark">
                            Confirme que <strong>{candidatoNome}</strong> esteve <strong>presente</strong> hoje
                        </p>
                        <small className="text-muted mt-2">Prosseguir para Heteroidentificação</small>
                    </div>
                </Modal.Body>
                <Modal.Footer className="border-0 pt-0 d-flex justify-content-center">
                    <Button variant="outline-secondary" size="sm" onClick={onHide}>
                        Voltar
                    </Button>
                    <Button
                        variant="success"
                        size="sm"
                        onClick={handleConfirmar}
                        disabled={!canConfirm}
                        style={canConfirm ? animatedButtonStyle : {}}
                    >
                        Prosseguir
                    </Button>
                </Modal.Footer>
            </Modal>
        </>
    );
};

export default ConfirmarInicioModal;